<template>
	<div class="button-group-wrap" :class="[padding ? 'button-group-wrap--padding' : 'button-group-wrap--normal']">
		<el-button
			v-for="(item, index) in options"
			:key="index"
			class="button-group-item"
			:class="{
				'button-group-item--active': item.value === innerValue
			}"
			@click="changeButton(item)"
			>{{ item.label }}</el-button
		>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	value: {
		type: [String, Number],
		default: ''
	},
	options: {
		type: Array,
		default: () => []
	},
	padding: {
		type: Boolean,
		default: false
	}
});
const innerValue = computed({
	get() {
		return props.value;
	},
	set(val) {
		emits('update:value', val);
	}
});

const emits = defineEmits(['update:value', 'change']);
// TODO useChange?
const changeButton = item => {
	if (innerValue.value === item.value) return;
	innerValue.value = item.value;
	emits('change', item);
};
</script>

<style lang="less" scoped>
.button-group-wrap {
	display: flex;

	&--normal {
		.button-group-item {
			margin-left: 0;
			border-radius: 0;
			padding: 0 10px;
			height: 1.8em;
			color: #1d2129;
			font-size: 1.1rem;
			line-height: 1.8em;
			font-family: 'SourceHanSansCN-Normal';

			& + .button-group-item {
				margin-left: -1px;
			}
			&:first-child {
				border-top-left-radius: 2px;
				border-bottom-left-radius: 2px;
			}
			&:last-child {
				border-top-right-radius: 2px;
				border-bottom-right-radius: 2px;
			}

			&--active {
				color: #21519d;
				border: 1px solid #21519d;
				// 让选中项的展示层级更高
				position: relative;
			}
		}
	}

	&--padding {
		.button-group-item {
			padding: 0 12px;
			height: 24px;
			line-height: 24px;
			border-radius: 2px;
			background: #f2f3f5;

			color: #86909c;
			font-family: 'SourceHanSansCN-Normal';
			font-size: 12px;
			font-style: normal;
			font-weight: 400;
			border: none;

			&--active {
				color: #21519d;
				background: rgba(33, 81, 157, 0.2) !important;
				font-weight: 500;
			}
			& + .button-group-item {
				margin-left: 12px;
			}
		}
	}
}
</style>


<style lang="less">
.Mobile {
	.button-group-wrap {
		display: flex;
		overflow-x: auto !important;
		overflow-y: hidden;
        padding-left: 2.1rem;
		position: relative;
		left: -2.1rem;
		right: -2.1rem;
		width: 100vw;
		// 解决ios滑动不流畅
		-webkit-overflow-scrolling: touch;
		&::-webkit-scrollbar {
			display: none;
		}

		&-item {
			flex-shrink: 0;
		}
	}
	.filter-other--expand {
		margin-top: 1.6rem !important;
	}
	.button-group-item {
		font-size: 1.5rem !important;
		height: auto;
	}
}
</style>